import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { EditFormRequest } from "./form"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { EditStateRequest } from "./editStateRequest"
import { ComplianceRequestsUpdate, ComplianceRequetsValidation, GetByIdComplianceRequests, resetComplianceRequestsStateStatus, resetComplianceRequestsValidationStatus, resetCreateStateRequest, resetDeleteStateStatus, resetGetByIdStateStatus, resetUpdateStatus, setEditCustomerOtherOdcDefault, setEditRequestDescription, setEditRequestNote, setEditRequestProduct, setEditRequestProtocolId, setEditRequestSender, setEditRequestType, setRequestId, setRequestStateDetails } from "../slice"
import { SuccessPopup } from "../../../../ui/organisms/successPopup"

export function EditRequestComplianceRequest() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const sessionState = useAppSelector(state => state.session)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    useEffect(() => {
        if (complianceRequestState.complianceRequestUpdateStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetUpdateStatus())
            const timer = setTimeout(() => {
                setShowSuccess(false)
                navigate('/complianceRequests')
            }, 2000);

            return () => clearTimeout(timer)
        }
    }, [complianceRequestState.complianceRequestUpdateStatus, dispatch, navigate])

    useEffect(() => {
        if (complianceRequestState.complianceRequestErrorsStatus === 'successfully') {
            dispatch(resetComplianceRequestsValidationStatus())
            dispatch(ComplianceRequestsUpdate(
                {
                    body: complianceRequestState.complianceRequestsUpdate,
                    id: complianceRequestState.complianceRequestId
                }
            ))
        }
    }, [complianceRequestState.complianceRequestErrorsStatus])

    useEffect(() => {
        if (complianceRequestState.ComplianceRequestStateDeleteStatus === 'successfully') {
            dispatch(resetDeleteStateStatus())
            dispatch(GetByIdComplianceRequests(complianceRequestState.complianceRequestId!))
        }
    }, [complianceRequestState.ComplianceRequestStateDeleteStatus])

    useEffect(() => {
        if (complianceRequestState.ComplianceRequestStateCreationStatus === 'successfully') {
            dispatch(resetComplianceRequestsStateStatus())
            dispatch(GetByIdComplianceRequests(complianceRequestState.complianceRequestId!))
            dispatch(resetCreateStateRequest())
        }
    }, [complianceRequestState.ComplianceRequestStateCreationStatus])



    useEffect(() => {
        if (complianceRequestState.getComplianceRequestByIdStatus === 'successfully') {
            dispatch(resetGetByIdStateStatus())
            if (complianceRequestState.getComplianceRequestsByIdResponse) {
                dispatch(setRequestStateDetails(complianceRequestState.getComplianceRequestsByIdResponse.complianceRequestStates))
                if (complianceRequestState.getComplianceRequestsByIdResponse.otherOdcCustomer &&
                    complianceRequestState.getComplianceRequestsByIdResponse.otherOdcCustomer?.length > 0) {
                    dispatch(setEditCustomerOtherOdcDefault(complianceRequestState.getComplianceRequestsByIdResponse.otherOdcCustomer))
                }

                dispatch(setRequestId(complianceRequestState.getComplianceRequestsByIdResponse.id))
                dispatch(setEditRequestDescription(complianceRequestState.getComplianceRequestsByIdResponse.description))
                dispatch(setEditRequestNote(complianceRequestState.getComplianceRequestsByIdResponse.note))
                dispatch(setEditRequestProtocolId(complianceRequestState.getComplianceRequestsByIdResponse.requestProtocolId))
                dispatch(setEditRequestSender(complianceRequestState.getComplianceRequestsByIdResponse.sender))
                dispatch(setEditRequestType(complianceRequestState.getComplianceRequestsByIdResponse.requestType))
                dispatch(setEditRequestProduct(complianceRequestState.getComplianceRequestsByIdResponse.product))
            }

        }
    }, [complianceRequestState.getComplianceRequestByIdStatus])


    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.GESTIONE_CERTIFICAZIONE} breadcrumbItems={['Gestione Certificazione', 'Richieste Conformità', 'Modifica Richiesta']}
                headerLabel="Modifica Richiesta Conformità"
                rightBar={true}
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/complianceRequests')} color={colors.white} />
                }
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent size={"sm"} iconPosition={"off"} variant={"solid"} label="Salva" color={"orange"}
                            onClick={() => {
                                dispatch(ComplianceRequetsValidation(complianceRequestState.complianceRequestsUpdate))
                            }}
                        />
                    </div>
                }

            >
                <div className="flex h-full min-h-full flex-col">
                    {
                        (showSuccess) &&
                        <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                            <SuccessPopup
                                active={showSuccess}
                                message="Dati salvati correttamente."
                                onClose={() => {
                                    dispatch(resetUpdateStatus())
                                    setShowSuccess(false)
                                }}
                            />
                        </div>
                    }

                    <div className="flex h-full flex-1 min-h-0 overflow-hidden">
                        <div className="flex-[0.6] h-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                            <EditFormRequest />
                        </div>

                        <div className="flex-[0.4] h-full overflow-y-auto bg-white">
                            <RightBar >
                                <EditStateRequest />
                            </RightBar>
                        </div>
                    </div>
                </div>

            </Layout>
        )
    }
    return (
        <Layout menuItem={MenuItems.GESTIONE_CERTIFICAZIONE} breadcrumbItems={['Gestione Certificazione', 'Richieste Conformità', 'Modifica Richiesta']}
            headerLabel="Modifica Richiesta Conformità"
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/complianceRequests')} color={colors.white} />
            }
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}